import { getModeColor } from 'z3k-settings/components/utils/ColorPicker4bit';
import { changeHeatingMode, changeHeatingModeForHeatingCircuit, } from 'console/redux/z3k-custom-command/actions';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
export function getZ3KHeatingModesConfig(device_id, heating_modes, show_hidden_elements) {
    const shared_heating_modes = heating_modes.map((heating_mode) => {
        const { id, name, heating_zones } = heating_mode;
        if (HeatingMode.isHidden(heating_mode) && !show_hidden_elements) {
            return null;
        }
        const color = getModeColor(heating_mode, id);
        const onSelectMode = (heating_circuit_id) => heating_circuit_id
            ? changeHeatingModeForHeatingCircuit(device_id, id, heating_circuit_id)
            : changeHeatingMode(device_id, id);
        const not_configured = heating_zones.length === 0;
        return {
            id,
            name: fixObjectName(name),
            color,
            onSelectMode,
            heating_zones,
            not_configured,
        };
    });
    return shared_heating_modes;
}
